import React from "react";
import { FaExclamationTriangle } from "react-icons/fa";

// Bitişi geçmiş, tamamlanmamış iş uyarısı. Kartın/satırın kırmızı yanıp sönmesi
// (animate-staleBlink) çağıran tarafta; bu yalnız ikon + "Gecikti" etiketi.
// compact: yalnız ikon (alt iş kartı gibi dar yerler).
export default function OverdueBadge({ compact = false, className = "" }) {
  return (
    <span
      className={`inline-flex items-center gap-1 text-red-700 font-SemiBold shrink-0 ${className}`}
      title="Bitiş tarihi geçti"
      data-testid="overdue-badge"
    >
      <FaExclamationTriangle className="w-3 h-3" aria-hidden="true" />
      {!compact && <span>Gecikti</span>}
    </span>
  );
}
